<template>
  <div class="wrapper">
    <loading-spinner
      :custom-id="'loading_spinner_' + iframeId"
      :loading-status="loading"
    />
    <div
      :class="['iframe-container', { 'iframe-container--visible': !(loading) }]"
    >
      <iframe :id="iframeId" />
    </div>
    <empty-state
      v-if="!(loading) && previewContent === null"
      icon="browser"
      :description="emptyStateDescription"
    />
  </div>
</template>
<script>
import LoadingSpinner from './LoadingSpinner'
import EmptyState from './EmptyState'

export default {
  components: {
    LoadingSpinner,
    EmptyState
  },
  inject: ['isLoading'],
  props: {
    iframeId: {
      type: String,
      required: false,
      default: 'iframe_container'
    },
    emptyStateDescription: String,
    previewContent: {
      type: String,
      required: false,
      default: 'iframe_container'
    }
  },
  data () {
    return {
      loadingStatus: true,
      timeout: null
    }
  },
  computed: {
    loading () {
      return this.loadingStatus || this.isLoading()
    }
  },
  watch: {
    previewContent: function (newVal, oldVal) {
      if (newVal !== oldVal && newVal !== null && newVal.length > 0) {
        this.setIframeContent(newVal)
      }
    }
  },
  mounted () {
    if (this.previewContent !== null && this.previewContent.length > 0) {
      this.setIframeContent(this.previewContent)
    }
  },
  beforeDestroy () {
    clearTimeout(this.timeout)
  },
  methods: {
    setIframeContent (content) {
      this.loadingStatus = true
      const iframe = document.getElementById(this.iframeId)
      if (iframe && iframe.contentWindow) {
        if (content == null || content.length === 0) {
          iframe.contentWindow.document.open()
          iframe.contentWindow.document.write('')
          iframe.contentWindow.document.close()
          iframe.height = 0
          iframe.width = 0
        } else {
          iframe.contentWindow.document.open()
          iframe.contentWindow.document.write(content)
          iframe.contentWindow.document.close()
          this.checkIframeLoaded(this.iframeId)
        }
      }
    },
    checkIframeLoaded (iframeId, minIterations = 5, maxIterations = 20, iterations = 0) {
      const iframe = document.getElementById(iframeId)
      if (iframe) {
        const sh = document.getElementById(iframeId).contentWindow.document.children[0].scrollHeight
        const sw = document.getElementById(iframeId).contentWindow.document.children[0].scrollWidth
        const ih = parseInt(iframe.height)
        const iw = parseInt(iframe.width)
        if (ih === 0 || iw === 0 || ih !== sh || iw !== sw) {
          iframe.height = sh
          iframe.width = sw
          iterations = 0
        } else {
          iterations++
        }
        if (iterations === minIterations) {
          this.loadingStatus = false
        }
      }
      if (iterations <= maxIterations) {
        this.timeout = setTimeout(() => {
          this.checkIframeLoaded(iframeId, minIterations, maxIterations, iterations)
        }, 200)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  display: block;
  position: relative;
  height: 100%;
  padding: 0;
}
.iframe-container {
  visibility: hidden;
  height: 100%;
  overflow: hidden;
  &--visible {
    visibility: visible;
    max-height: none;
    overflow: initial;
  }
  iframe {
    border: 0;
    overflow: auto;
    width: 100%;
    margin: 0 auto;
    display: block;
  }
}
</style>
